module.exports = __webpack_public_path__ + "static/newyork-96d192a3a6a03c2eecfe5e5173e98af8.jpg";